<template>
  <div>
    <div class="章程法令規章-學會章程內容">
      <div class="章程法令規章-學會章程內容__a2188fc3e9ea4b7d93eda3732877116e headline">
        一、 總則
        <br />
        <br />( 民國九十四年九月十一日第一屆第一次會員大會通過 )
        <br />
        <br />第 一 條、本會名稱為「台灣血管外科學會」，正式英文名稱為「Taiwan Society for Vascular
        Surgery」，英文簡稱TSVS（以下簡稱本會）。 <br />第 二
        條、本會為依法設立、非以營利為目的之社會團體。以聯絡國內外人士共同發揚血管外科醫學之研究、教學、及應用，增進全民健康及國際學術交流為宗旨。
        <br />第 三 條、本會以全國行政區域為組織區域。 <br />第 四
        條、本會會址設於主管機關所在地區，並得報經主管機關核准設辦事處與分支機構。前項分支機構組織簡則，由理事會擬訂，報請主管機關核准後行之。會址及分支機構之地止於設置及變更時，應報請主管機關核備。
        <br />第 五 條、本會之任務如下： <br />一、
        促進、鼓勵及改善所有血管疾病健康知識的傳遞，並教育所有大眾血管疾病的保健及照顧。 <br />二、
        提供血管外科醫師對於新的手術技術以及知識的教育。 <br />三、
        做為所有會員在血管外科所有領域，包括血管內手術的支持組織。 <br />四、 促進改善血管疾病病人的診斷及治療。
        <br />五、 清楚的定位出外科手術、血管內手術、以及藥物治療對於血管疾病的治療與預防。 <br />六、
        鼓勵血管疾病的臨床及基礎研究。 <br />七、 鼓勵對於血管疾病診斷及治療上新技術的發展及執行，並協助建立血管診察室。
        <br />八、 審議有關血管疾病命名及標準，並協助政府與民間制定血管疾病之政策及方案。 <br />九、
        規範血管外科有關的社會倫理及法律事項。 <br />十、 提供對血管外科有興趣的外科醫師專門的訓練。
        <br />十一、舉辦學術演講及討論。 <br />十二、編輯會訊及有關書刊。
        <br />十三、甄審血管外科醫師、血管外科專科指導醫師,以及評鑑培訓血管外科醫師教學醫院，並有頒發證書之資格。
        <br />十四、獎助血管外科人才及舉辦其他有關事宜。 <br />十五、其他章程所訂宗旨及任務相關事項。 <br />第 六
        條、本會之主管機關為內政部。相關目的的事業主管機關依章程所訂宗旨、任務為行政院衛生署及教育部。目的事業應受各該事業主管機關之指導、監督。
        <br />
        <br />
        <br />二、 會員
        <br />
        <br />第 七 條、本會會員分下列四種：
        <br />一、一般會員：對血管外科有興趣者，經本會理事會通過並繳納會費者，得為本會一般會員。
        <br />二、專科醫師會員：凡在國內、外醫學院系以上畢業，具外科專科醫師資格，依本會甄審原則甄審合格後，經本會理事會通過並繳納會費者，得為本會專科醫師會員。
        <br />三、贊助會員：凡對本會在經濟或其他方面有實際贊助者，經本會理事會通過者，得聘請為二年期贊助會員。
        <br />四、榮譽會員：凡對本會有特殊貢獻，經本會理事會通過者，得聘請為榮譽會員。 <br />第 八
        條、專科醫師會員﹝會員代表﹞有表決權、選舉權、被選舉權與罷免權。每一會員為一權。但是「一般會員」、「贊助會員」以及「榮譽會員」無表決權、選舉權、被選舉權與罷免權。
        <br />第 九 條、會員有遵守本會章程、決議及繳納會費之義務。 <br />第 十
        條、會員（會員代表）有違反法令、章程或不遵守會員大會決議時，得經理事會決議，予以警告或停權處分，其危害團體情節重大者，得經會員大會決議予以除名。「會員未繳納會費者，不得享有會員權利，連續二年
        <br />
        未繳納會費者，視為自動退會。會員經出會、退會或停權處分，如欲申請復會或復權時，除有正當理由者外，應繳清前所積欠之會費。」
        <br />第十一條、會員有下列事情之一者，為出會： <br />一、 喪失會員資格者。 <br />二、 經會員大會決議除名者。
        <br />第十二條、會員得以書面敘明理由向本會聲明退會。
        <br />
        <br />
        <br />三、 組織及職權
        <br />
        <br />第十三條、本會以會員大會為最高權力機構。會員人數超過三百人以上時得分區比例選出會員代表，再召開會員代表大會，行使會員大會職權。會員代表任期二年。其各名額及選舉辦法由理事會擬訂，報請主管機關核備後行
        <br />
        之。會員大會閉會期間由理事會代行職權；監事會為監察機構。 <br />第十四條、會員﹝會員代表﹞大會之職權如下：
        <br />一、 訂定與變更章程。 <br />二、 選舉或罷免理事、監事。 <br />三、
        議決入會費、常年會費、事業及會員捐款之數額及方式。 <br />四、 議決年度工作計畫、報告及預算、決算。 <br />五、
        議決會員﹝會員代表﹞之除名處分。 <br />六、 議決財產之處分。 <br />七、 議決本會之解散。 <br />八、
        議決與會員權利義務有關之其他重大事項。 <br />前項第八款重大事項之範圍由理事會訂之。
        <br />第十五條、本會置理事二十一人、監事七人，由會員選舉之，分別成立理事會、監事會。選舉前項理事、監事時，依計票情形得同時選出候補理事五人、候補監事二人，遇理事、監事出缺時，分別依序遞補之。本屆理事會得
        <br />
        提出下屆理事、監事候選人參考名單。理事、監事得採用通訊選舉；但不得連續辦理。通訊選舉辦法由理事會通過，報主管機關核備後行之。
        <br />第十六條、理事會之職權如下： <br />一、 議決會員大會之召開事項。 <br />二、 審定會員﹝會員代表﹞之資格。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocietyCharter"
};
</script>

<style></style>

<style lang="scss">
.章程法令規章-學會章程內容 {
  &__a2188fc3e9ea4b7d93eda3732877116e {
    font-size: 11px;
    color: #121a33;
  }
}
</style>
